import projectsModel from '../../../models/projects';
import projectComponent from '../../../components/Project';
import moment from 'moment';
import Store from '../../../store/main';
import rights from '../../../components/rights/index';

class Portfolio {
  createReport(projectIds) {
    const reportPortfolioResult = projectIds.map(ganttID => {
      const { id, name } = projectsModel.getProjectDataById(ganttID);

      const status = this._getStatus(ganttID);
      const progress = this._getProgress(ganttID);
      const start_date = this._getStartDate(ganttID);
      const end_date = this._getEndDate(ganttID);
      const creator = this._getCreator(ganttID);
      const project = { id, name };

      return {
        id, project, status, progress, start_date, end_date, creator,
      };
    });

    return reportPortfolioResult;
  }

  _getProgress(ganttID) {
    return {
      percentage: Math.floor(this._getTotalEstimate(ganttID).progress * 100),
      ...this._getTasksCount(ganttID),
    };
  }

  _getStatus(ganttID) {
    const projectStatusesLocales = ['no_status_locale', 'on_track_locale', 'at_risk_locale', 'off_track_locale'];
    const statusData = Store.getters['teamSetting/statusDataForProject'](ganttID);
    const {
      id,
      value: label,
      labelColor,
      background: backgroundColor,
    } = statusData.selectOption;

    return {
      id,
      label: projectStatusesLocales.includes(label) ? __(label) : label,
      labelColor,
      backgroundColor,
    };
  }

  _getTotalEstimate(ganttID) {
    return Store.getters['tasksModel/getTotalEstimateDataForProject'](ganttID);
  }

  _getStartDate(ganttID) {
    return moment(this._getTotalEstimate(ganttID).start_date).format(user.dateFormat);
  }

  _getEndDate(ganttID) {
    return moment(this._getTotalEstimate(ganttID).end_date).format(user.dateFormat);
  }

  _getCreator(ganttID) {
    return rights.project.getOwnerByGanttId(ganttID) || { name: '', photo: null };
  }

  _getTasksCount(ganttID) {
    const {
      countOfOverdue,
      countOfSlightlyOverdue,
      countOfPerSchedule,
    } = projectComponent.getProjectsList().find(item => item.id === ganttID);

    return {
      countOfOverdue,
      countOfSlightlyOverdue,
      countOfPerSchedule,
    };
  }
}

const portfolio = new Portfolio();

export default portfolio;
